import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import {
  aiChecklistCreateResponseCodec,
  aiChecklistJobStatusResponseCodec,
  aiPromptCodec,
  aiPromptIdeasResponseCodec,
} from './codec';
import {
  authHeaders,
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createPostRequest,
  decode,
  fetchApi,
  filesToFormData,
  formMultipartHeadersWithJson,
  setBody,
  setBodyFormData,
} from '../..';

const baseUrl = '/v2/checklists';
const aiUploadUrl = `${baseUrl}/ai/upload`;
const aiPromptUrl = `${baseUrl}/ai/prompt`;
const statusUrl = (uuid: string) => `${baseUrl}/ai/${uuid}/status`;

export const uploadAi = (files: File[]) => pipe(
  aiUploadUrl,
  authHeaders(formMultipartHeadersWithJson(createPostRequest)),
  map(setBodyFormData(filesToFormData(files))),
  chain(fetchApi),
  chain(decode(aiChecklistCreateResponseCodec)),
);

export const textPromptAi = (prompt: string) => pipe(
  aiPromptUrl,
  createAuthorizedPostRequest,
  map(setBody(aiPromptCodec.encode({ prompt }))),
  chain(fetchApi),
  chain(decode(aiChecklistCreateResponseCodec)),
);

export const status = (uuid: string) => pipe(
  statusUrl(uuid),
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(aiChecklistJobStatusResponseCodec)),
);

export const promptIdeas = () => pipe(
  aiPromptUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(aiPromptIdeasResponseCodec)),
);
